/**
 * Developer-settings toggle for broker loadboard source visibility.
 *
 * Hidden sources are removed from the source pickers on Load Hub, Load Radar,
 * and AI Hub. Only the broker boards (AIHub extension boards, credential
 * loadboards, and DAT via the extension) are toggleable — always-available
 * sources (TruckStop Trial, Parade, HappyRobot, Telegram, Numeo Loads) are
 * never hidden.
 *
 * Stored project-wide in `application.temp.updater.developerSettings.hiddenBrokerSources`
 * (same home as the other developer settings), edited from Settings → Developer
 * Settings via the updater settings API. Hiding a source does not touch
 * already-saved tab/radar selections, it only removes the option from pickers.
 */
import { useAuth } from 'hooks/auth'
import { AIHUB_SOURCES, DAT_EXTENSION_SOURCES, LOADBOARD_SOURCES } from '../utils/constants'

/** Source values the user may hide — the broker boards (including DAT via the extension). */
export const TOGGLEABLE_BROKER_SOURCES: readonly string[] = [...AIHUB_SOURCES, ...LOADBOARD_SOURCES, ...DAT_EXTENSION_SOURCES]

const EMPTY_HIDDEN_SOURCES: string[] = []

/** Hidden broker source values for the current project (stable `[]` when none). */
export const useHiddenBrokerSources = (): string[] => {
    const { application } = useAuth()
    return application?.temp?.updater?.developerSettings?.hiddenBrokerSources ?? EMPTY_HIDDEN_SOURCES
}
